import { UseProjectsListReturnData } from "@/lib/useQuery/project/useProjectsList";
import { createSortConfig } from "./SortConfigBuilder";
import { AArrowDown, AArrowUp, CalendarArrowDown, CalendarArrowUp } from "lucide-react";
import { UseGetQuestionsBySurveyIdReturnData } from "@/features/question/hooks/useQuery/useGetQuestionsBySurveyId";

export const projectSortConfig = createSortConfig<UseProjectsListReturnData[number]>()
    .addDateField(
        'created_at',
        { asc: 'Created (Oldest First)', desc: 'Created (Newest First)' },
        { asc: <CalendarArrowDown size={16} />, desc: <CalendarArrowUp size={16} /> }
    )
    .addStringField(
        'name',
        { asc: 'Name (A-Z)', desc: 'Name (Z-A)' },
        { asc: <AArrowDown size={16} />, desc: <AArrowUp size={16} /> }
    )
    .build();


export const questionsSortConfig = createSortConfig<UseGetQuestionsBySurveyIdReturnData['questions'][number]>()
    .addDateField(
        'created_at',
        { asc: 'Created (Oldest First)', desc: 'Created (Newest First)' },
        { asc: <CalendarArrowDown size={16} />, desc: <CalendarArrowUp size={16} /> }
    )
    .addStringField(
        'question',
        { asc: 'Question (A-Z)', desc: 'Question (Z-A)' },
        { asc: <AArrowDown size={16} />, desc: <AArrowUp size={16} /> }
    )
    .build();